module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "impresso"
  }, [_c('div', {
    staticClass: "cabecalho"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require('../../assets/brasao-pms.png'),
      "alt": "Logo prefeitura"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "via"
  }, [_c('b', [_vm._v(_vm._s((_vm.via + "ª VIA")))]), _vm._v("\n      " + _vm._s((" - " + _vm.destino)) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "data-cabecalho"
  }, [_c('div', {
    staticClass: "nesta"
  }, [_vm._v("NESTA")]), _vm._v(" "), _c('div', {
    staticClass: "data"
  }, [_vm._v("\n      Santos,\n      "), (_vm.mostraSolicitada) ? _c('span', [_c('date-picker', {
    staticClass: "form-control data-texto",
    attrs: {
      "name": "dataSolicitacao",
      "id": "dataSolicitacao",
      "config": _vm.config
    },
    model: {
      value: (_vm.dataSolicitacao),
      callback: function($$v) {
        _vm.dataSolicitacao = $$v
      },
      expression: "dataSolicitacao"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm._f("extenso")(_vm.dataSolicitacao)))])])]), _vm._v(" "), _c('div', {
    staticClass: "corpo"
  }, [_vm._v("\n    " + _vm._s(_vm.nomeServidor) + ", registro nº " + _vm._s(_vm.servidor.registroFormatado) + ", ocupante\n    do(a) " + _vm._s(_vm.servidor.cargoPrincipal) + ", lotado(a) na\n    " + _vm._s(_vm.servidor.siglaUnidadeOrganizacional) + ", faltará no serviço no dia\n    "), (_vm.mostraFalta) ? _c('span', [_c('date-picker', {
    staticClass: "form-control data-texto",
    attrs: {
      "name": "dataFalta",
      "id": "dataFalta",
      "config": _vm.config
    },
    model: {
      value: (_vm.dataFalta),
      callback: function($$v) {
        _vm.dataFalta = $$v
      },
      expression: "dataFalta"
    }
  })], 1) : _c('span', [_vm._v(_vm._s(_vm._f("extenso")(_vm.dataFalta)))]), _vm._v("\n    , vindo pelo presente solicitar o ABONO da falta, de acordo com a lei nº\n    4.623/84, de 12 de junho de 1984.\n  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "rodape"
  }, [_vm._v("COSUPRI - SEAD/029")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo"
  }, [_c('h1', [_vm._v("PREFEITURA DE SANTOS")]), _vm._v(" "), _c('h2', [_vm._v("Abono de falta - Lei Nº 4.623/84")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "despacho"
  }, [_vm._v("\n    DESPACHO: _________________________________\n    "), _c('br'), _vm._v("____________________________________________ "), _c('br'), _vm._v("Em\n    _________/_________/_____________\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "assinaturas"
  }, [_c('div', {
    staticClass: "funcionario"
  }, [_c('div', {
    staticClass: "linha"
  }, [_vm._v("___________________________________________")]), _vm._v(" "), _c('div', {
    staticClass: "inscricao"
  }, [_vm._v("Assinatura do funcionário")])]), _vm._v(" "), _c('div', {
    staticClass: "chefe"
  }, [_c('div', {
    staticClass: "linha"
  }, [_vm._v("VISTO: ____________________________________")]), _vm._v(" "), _c('div', {
    staticClass: "inscricao"
  }, [_vm._v("\n        (Assinatura e carimbo)\n        "), _c('br'), _vm._v("CHEFE DA UNIDADE\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f9fc508","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/falta-lei/impresso.vue
// module id = B6Ps
// module chunks = 5